import {StyledAuth, StyledLink} from "./style";
import {MyButton, MyText} from "../../components";
import {Col, Flex, Form, Input, Row, message} from "antd";
import {LogoIcon} from "../../assets";
import {Link} from "react-router-dom";
import {useState, useEffect} from "react";
import {LockOutlined, UnlockOutlined} from "@ant-design/icons"; 
import {LANG_KEY} from "../../utils/constants/language";
import {MySegmented} from "../../components";
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { fetchConfirmResetPasswordAction, ROUTE_PATH } from "../../utils/"
import { useSelector } from "react-redux";
import { selectStore } from "../../utils/";
import { KeyOutlined } from "@ant-design/icons";
import { fetchRestore } from "../../utils/";
import { useDispatch } from "react-redux";
import { useEmbeddedLink } from "../../utils/context/embed";
import { setRestoreData } from "../../utils/";
import { useEmbeddedNavigate } from "../../utils/context/embed";
const FORM_NAME = {
  email: 'email',
  phone: 'phone',
};

export const RestorePassword = () => {
  const {t} = useTranslation("common")
  const [form] = Form.useForm();
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [password, setPassword] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");
  const [passwordMismatch, setPasswordMismatch] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const [timer, setTimer] = useState(59);
  const [canResend, setCanResend] = useState(false); 
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();
  const location = useLocation();
  const {profile: {restoreData: restoreDataState}} = useSelector(selectStore);
  const confirmResetPassword = useSelector((state: any) => state.profile?.confirmResetPassword ?? { loading: false });

  const dispatch = useDispatch();
  const [errors, setErrors] = useState([]);
  const embeddedLink = useEmbeddedLink();

  const [formData, setFormData] = useState({
    password: '',
    password_repeat: '',
  });

  const { username } = location.state || {};

  // useEffect(() => {
  //   const checkFields = () => {
  //     const hasErrors = form.getFieldsError().some(({ errors }) => errors.length > 0);
  //     const allFieldsFilled = form.isFieldsTouched(true) && !hasErrors;
  //     const isValidPassword = password && password === passwordRepeat;

  //     setIsButtonDisabled(!allFieldsFilled || !isValidPassword);
  //   };

  //   checkFields();
  // }, [form, password, passwordRepeat]);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    setPasswordMismatch(e.target.value !== passwordRepeat);
  };

  const handlePasswordRepeatChange = (e) => {
    setPasswordRepeat(e.target.value);
    setPasswordMismatch(e.target.value !== password);
  };

  // const handleSaveNewPassword = async () => {
  //   try {
  //     const response = await confirmResetPassword({
  //       username: restoreDataState?.data?.username,
  //       password_reset_token: verificationCode,
  //       new_password: formData.password,
  //     });
  //     dispatch(setRestoreData());
  //     message.success(response.message || 'Пароль успешно сброшен');
  //     embeddedNavigate('/');
  //   } catch (error) {
  //     const errorData = error?.response?.data;
  //     setErrors(errorData?.errors || []);
  
  //     message.error(errorData?.message || 'Ошибка сброса пароля');
  //   }
  // };

  const handleSaveNewPassword = () => {
    dispatch(fetchConfirmResetPasswordAction({
      username: restoreDataState?.data?.username,
      password_reset_token: verificationCode,
      new_password: formData.password,
    }));
  };

  useEffect(() => {
    if (!confirmResetPassword.success) return;
    message.success(confirmResetPassword.data?.message || 'Пароль успешно сброшен');
    embeddedNavigate('/');
  }, [confirmResetPassword.success]);

  useEffect(() => {
    if (!confirmResetPassword.failed) return;
    const errorData = confirmResetPassword.data;
    setErrors(errorData?.errors || []);
    message.error(errorData?.message || 'Ошибка сброса пароля');
  }, [confirmResetPassword.failed]);

  const isFormValid = () => {
    const { password, password_repeat } = formData;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    
    
  
    const isPasswordValid = passwordRegex.test(password) && password === password_repeat;
  
    return isPasswordValid;
  };

  useEffect(() => {
    setIsButtonDisabled(!isFormValid());
  }, [formData]);


  const handleResendCode = async () => {
    try {
      await dispatch(fetchRestore({ 
        username: restoreDataState?.data?.username, 
        type: restoreDataState?.data?.type 
      }));
      setCanResend(false);
      setTimer(59);
    } catch (error) {
      message.error(error.message || 'Не удалось отправить код повторно');
    }
  };

    useEffect(() => {
      let interval = null;
      if (!canResend && timer > 0) {
        interval = setInterval(() => {
          setTimer((prevTimer) => prevTimer - 1);
        }, 1000);
      } else if (timer === 0) {
        setCanResend(true);
        clearInterval(interval);
      }
      return () => clearInterval(interval);
    }, [timer, canResend]);

  return (
    <StyledAuth>
      <div
        style={{
          position: 'absolute',
          top: 40,
          right: 40,
        }}
      >
        <MySegmented
          options={[
            {
              label: 'ҚАЗ',
              value: LANG_KEY.KZ,
            },
            {
              label: 'РУС',
              value: LANG_KEY.RU,
            },
          ]}
        />
      </div>

      <Flex
        justify="center"
        align="center"
        style={{
          width: 500,
        }}
      >
        <Row justify="center" gutter={[16, 16]}>
          <Col>
            <Link to={embeddedLink(ROUTE_PATH.MAIN)}>
            <LogoIcon />
            </Link>
          </Col>
          <Col span={24}>
            <Flex justify="center">
              <MyText align="center" size={20} lineHeight="32px" weight={400}>
                {t('newPassword')}
              </MyText>
            </Flex>
          </Col>
          <Col span={24}>
            <Row justify="center">
            </Row>
          </Col>
          <Col span={24}>
            <Form
              form={form}
              // onFieldsChange={() => {
              //   const hasErrors = form.getFieldsError().some(({ errors }) => errors.length > 0);
              //   const allFieldsFilled = form.isFieldsTouched(true) && !hasErrors;
              //   const isValidPassword = password && password === passwordRepeat;

              //   setIsButtonDisabled(!allFieldsFilled || !isValidPassword);
              // }}
            >
            <Row>
              <Col span={24}>
                  <Form.Item name={FORM_NAME.email} labelCol={{ span: 24 }} style={{ marginBottom: 0 }} 
                   validateStatus={errors.some((err) => err.field === "password_reset_token") ? "error" : ""}
                   help={errors.find((err) => err.field === "password_reset_token")?.message}
                   >
                    <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                      {t("confirmCode")}
                    </MyText>
                    <Input
                      style={{ marginTop: 8 }}
                      prefix={<KeyOutlined style={{ color: '#969BAB' , marginRight: 8 }} />}
                      placeholder={t("enterCode")}
                      value={verificationCode}
                      onChange={(e) => setVerificationCode(e.target.value)}
                    />
                    <StyledLink 
                      onClick={canResend ? handleResendCode : null}
                      style={{ color: canResend ? '#0000EE' : '#969BAB', cursor: canResend ? 'pointer' : 'not-allowed' }}
                    >
                      {canResend ? t("resendCode") : `${t("resendIn")} ${timer} сек`}
                    </StyledLink>
                  </Form.Item>
                </Col>
                </Row>
              <Row style={{marginTop: 16}}>


                <Col span={24}>
                  <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                    {t("createPassword")}

                  </MyText>
                  <Form.Item
                  name="password"
                  labelCol={{ span: 24 }}
                  style={{ marginTop: 8 }}
                  rules={[
                    { required: true, message: t("enterPassword") },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
                        if (value && !passwordRegex.test(value)) {
                          return Promise.reject(t("passwordRegex"));
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
              <Input.Password
                name="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}

                prefix={<KeyOutlined style={{ color: '#969BAB', marginRight: 8 }} />}
                placeholder={t("enterPassword")}                      
              />
            </Form.Item>
                </Col>
                <Col span={24}>
                  <MyText color="rgba(76, 76, 77, 1)" size={18} lineHeight={'24px'} weight={600}>
                    {t("repeatPassword")} 
                  </MyText>
                  <Form.Item labelCol={{ span: 24 }} style={{ marginTop: 8 }} rules={[{ required: true, message: t("repeatPassword") }]}>
                    <Input.Password
                      name="password_repeat"
                      value={formData.password_repeat}
                      onChange={(e) => setFormData({ ...formData, password_repeat: e.target.value })}
                      prefix={<KeyOutlined style={{ color: '#969BAB' , marginRight: 8 }} />}
                      placeholder={t("enterPassword")}
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item>
                    <MyButton
                      type="primary"
                      htmlType="submit"
                      color="orange"
                      style={{ width: '100%', fontSize: '18px' }}
                      disabled={isButtonDisabled}
                      onClick={handleSaveNewPassword}
                    >
                      {t("save")}
                    </MyButton>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Flex>
    </StyledAuth>
  );
};
